//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import {
  searchGoods
} from '../../service/index'
import Type from './Type'

export default {
  data() {
    return {
      searchState: true,
      keyWord: '',
      selectMenu: false,
      cid: this.$route.query.cid,
      badgeAnimation: false
    }
  },
  components: {
    Type
  },
  props: {
    menuData: {
      type: Array,
      default: [],
    },
    currentActivityEnd: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.keepLang()
    //this.showSearch = this.$route.path.indexOf('home') >= 0
  },
  activated() {

  },
  computed: {
    ...mapState([
      'global', 'cartList', 'campaign', 'searchKey'
    ]),
    searchKey2: {
      get() {
        return this.searchKey
      },
      set(val) {
        this.initSearchKeyword(val)
      }

    },
    showSearch() {
      return this.$route.path.indexOf('home') >= 0
    },
    activeKey() {
      if (this.$route.query.cat) {
        return this.$route.query.cat.toString();
      } else if (this.$route.query.type) {
        return this.$route.query.type.toString();
      } else {
        return 'notexsited'
      }
    },
    cartNum() {
      if (this.cartList.cartNum) {
        return this.cartList.cartNum > 99 ? '99+' : this.cartList.cartNum;
      }
      return 0
    },
    menuLength() {
      return 10 - (this.menuData.length * 2)
    }
  },
  watch: {
    $route(to) {
      console.log(to)
      this.cid=this.$route.query.cid
    },
    searchState(newValue, oldValue) {
      if (!newValue) {
        this.$nextTick(_ => this.$refs.searchInput.focus())
      }
    },
    cartList: {
      handler(newValue, oldValue) {
        if (oldValue.cartNum != 0 && newValue.cartNum != oldValue.cartNum) {
          this.badgeAnimation = true
          setTimeout(() => {
            this.badgeAnimation = false
          }, 1000)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      initGoods: 'INIT_GOODS',
      initSearchKeyword: 'SEARCH_KEYWORD',
      changePage: 'CHANGE_PAGE'
    }),
    changeSearchState() {
      this.searchState = !this.searchState;
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    searchStateTrue() {
      this.searchState = true
      this.initSearchKeyword('')
    },
    goCart() {
      this.$router.push({
        path: '/cart',
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    goMy() {
      this.$router.push({
        path: '/order',
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    exit() {
      window.location.href = "/is/auth/logout/" + this.$route.query.cid;
    },
    async searchKeyWord(value) {
      //console.log('value',value)
      //this.initSearchKeyword(value)
      const res = await searchGoods(this.$route.query.cid, {
        keyword: value
      });
      if (res.status === 0) {
        this.initGoods(res.data)
      }
      this.changePage(1)
      this.initSearchKeyword(value)
      
    },
    // 中英文切换事件
    switchLang() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zh';
        localStorage.locale = 'zh';
      } else {
        this.$i18n.locale = 'en';
        localStorage.locale = 'en';
      }
    },
    // 刷新页面保存语言
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
    doCatSelect(menu) {
      this.changePage(1)
      this.initSearchKeyword('')
      this.activeKey = menu.id.toString()
      this.$router.push({
        path: `/home/${this.cid}`,
        query: {
          type: menu.id,
          cid: this.cid
        }
      })
    },
    menuRoute(menu, item) {
      this.changePage(1)
      this.initSearchKeyword('')
      this.activeKey = item.id.toString()
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query: {
          cid: this.$route.query.cid,
          type: menu.id,
          cat: item.id,
          refresh: 1
        }
      })
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/menu/Menu.vue